import { cn } from '@/context/global/utils/cn';

type IconMicrophoneOnProps = {
  size?: number;
  className?: string;
};

const IconDashCircle = ({ size = 16, className }: IconMicrophoneOnProps) => {
  return (
    <svg
      className={cn('fill-current', className)}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_671_17379)">
        <path
          d="M8 0.5C9.98912 0.5 11.8972 1.28977 13.3037 2.69629C14.7102 4.10281 15.5 6.01088 15.5 8C15.5 9.98912 14.7102 11.8972 13.3037 13.3037C11.8972 14.7102 9.98912 15.5 8 15.5C6.01088 15.5 4.10281 14.7102 2.69629 13.3037C1.28977 11.8972 0.5 9.98912 0.5 8C0.5 6.01088 1.28977 4.10281 2.69629 2.69629C4.10281 1.28977 6.01088 0.5 8 0.5ZM4.5 7C4.23478 7 3.9805 7.10543 3.79297 7.29297C3.60543 7.4805 3.5 7.73478 3.5 8C3.5 8.26522 3.60543 8.51949 3.79297 8.70703C3.98051 8.89457 4.23478 9 4.5 9H11.5C11.7652 9 12.0195 8.89457 12.207 8.70703C12.3946 8.51949 12.5 8.26522 12.5 8C12.5 7.73478 12.3946 7.48051 12.207 7.29297C12.0195 7.10543 11.7652 7 11.5 7H4.5Z"
          fill="currentColor"
          stroke="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_671_17379">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconDashCircle;
